import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/brand-images/a-fram-with-chairs.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/brand-images/indoor-fireplace.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/brand-images/modern-barn.jpg");
